import { message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const PlufginDector = () => {
  const [api, contextHolder] = message.useMessage();

  const [text, setText] = useState<string>();
  const domRef = useRef<HTMLDivElement>(null);
  const showWarnning = useRef(false);

  const hideMessage = () => {
    showWarnning.current = false;
    api.destroy('pluginError');
  };

  const showMessage = () => {
    showWarnning.current = true;
    api.warning({
      content: <FormattedMessage id="bc-translation-plugin-interfere" />,
      key: 'pluginError',
      duration: 0,
    });
  };

  useEffect(() => {
    setText(navigator.language === 'zh-CN' ? '插件' : 'Plugin');
  }, []);

  useEffect(() => {
    if (!domRef.current || !text) return;

    const observer = new MutationObserver((mutations) => {
      if (mutations[0].target.textContent !== text) {
        if (showWarnning.current) return;
        showMessage();
      } else {
        hideMessage();
      }
    });

    observer.observe(domRef.current, {
      childList: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [domRef.current, text]);

  return (
    <div className="absolute left-0 top-0 invisible">
      {contextHolder}
      <span ref={domRef}>{text}</span>
    </div>
  );
};

export default PlufginDector;
